import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { EquipmentApi, SrcLiteVoucher, SrcLiteVoucherStatus } from '@vi-iot/client';
import { ViToastService } from '@vi-iot/ui';

import { VouchersActions } from './vouchers.actions';

@Injectable()
export class VouchersEffects {
  generateSrcLiteVoucher$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(VouchersActions.GenerateVoucher),
      switchMap((action) =>
        this.equipmentApi.generateSrcLiteVoucher(action.voucherType, action.companyNumber).pipe(
          map((response: SrcLiteVoucher) =>
            VouchersActions.GenerateVoucherSuccess({
              voucherCode: response.voucherCode,
            })
          ),
          catchError((error) => {
            this.toastService.error({
              message: this.translateService.instant('+VOUCHERS.SERVER_ERROR'),
            });

            return of(VouchersActions.GenerateVoucherError({ error }));
          })
        )
      )
    );
  });

  validateSrcLiteVoucher$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(VouchersActions.ValidateVoucher),
      switchMap((action) =>
        this.equipmentApi.validateSrcLiteVoucher(action.voucher).pipe(
          map((response: SrcLiteVoucherStatus) =>
            VouchersActions.ValidateVoucherSuccess({ status: response.status })
          ),
          catchError((error) => of(VouchersActions.ValidateVoucherError({ error })))
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private equipmentApi: EquipmentApi,
    private toastService: ViToastService,
    private translateService: TranslateService
  ) {}
}
